import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import axios from 'axios'
import frontmatter from '@github-docs/frontmatter'
import slugify from 'slugify'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: () => ({
    theme: 'dark',
    contributions: [],
    menuOpen: false,
    blogPosts: {}
  }),
  mutations: {
    toggleState (state) {
      state.theme === 'dark'
        ? state.theme = 'light'
        : state.theme = 'dark'
    },
    toggleMenu (state) {
      state.menuOpen
        ? state.menuOpen = false
        : state.menuOpen = true
    },
    closeMenu (state) {
      state.menuOpen = false
    },
    setContributions (state, { contributions }) {
      state.contributions = contributions
    },
    async setBlogPosts (state, { posts }) {
      state.blogPosts = posts
    }
  },
  actions: {
    fetchContributions (context) {
      if (context.state.contributions.length === 0) {
        return fetch('https://github-contributions-api.now.sh/v1/watzon').then(async (con) => {
          const data = await con.json()
          context.commit('setContributions', { contributions: data.contributions })
        })
      }
    },
    async loadBlogPosts (context) {
      const res = await axios.get('https://api.github.com/repos/watzon/watzon.tech-contents/contents/posts')
      const links = res.data.reduce((m, x) => {
        m.push(x)
        return m
      }, [])
      for (let link of links) {
        const name = slugify(link.name.replace('.md', ''))
        if (!context.state.blogPosts[name]) {
          const response = await axios.get(link.download_url)
          const markdown = response.data
          let { data, content, } = frontmatter(markdown) // eslint-disable-line comma-dangle
          data.slug = name
          content = content.trim()
          context.state.blogPosts[name] = { data, content, link }
        }
      }
    }
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
